var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-email-templates-dropdown" }, [
    _c(
      "button",
      {
        ref: "promptButton",
        staticClass:
          "complete-app btn btn-primary btn-sm right dropdown-toggle ai-email-templates-dropdown__button",
        attrs: {
          id: "prompt-button",
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [
        _c(
          "span",
          { staticClass: "ai-email-templates-dropdown__button-content" },
          [_c("span", [_vm._v(_vm._s(_vm.$t("email.custom.templatesButton")))])]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu ai-email-templates-dropdown__menu",
        attrs: { id: "prompt-dropdown", "aria-labelledby": "prompt-button" },
      },
      [
        _c(
          "button",
          {
            staticClass: "dropdown-item ai-email-templates-dropdown__item",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.handleOpenModal("save")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "ai-email-templates-dropdown__item-title" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("email.custom.saveTemplate")) +
                    "\n      "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-divider" }),
        _vm._v(" "),
        _c(
          "button",
          {
            class: [
              "dropdown-item",
              "ai-email-templates-dropdown__item",
              { disabled: !_vm.showLoadOption },
            ],
            attrs: {
              type: "button",
              "aria-disabled": !_vm.showLoadOption,
              disabled: !_vm.showLoadOption,
            },
            on: {
              click: function ($event) {
                return _vm.handleOpenModal("load")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "ai-email-templates-dropdown__item-title" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("email.custom.selectTemplate")) +
                    "\n      "
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }